import React, { Component } from 'react';
import { getAssetHost } from './assetHost';
import './MaintenanceOverlay.scss';

class MaintenanceOverlay extends Component {
  componentDidMount() {
    if (document.activeElement && document.activeElement.blur) {
      document.activeElement.blur();
    }
    document.addEventListener('keydown', this.blockPageInteraction, true);
    document.addEventListener('submit', this.blockPageInteraction, true);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.blockPageInteraction, true);
    document.removeEventListener('submit', this.blockPageInteraction, true);
  }

  blockPageInteraction = (event) => {
    if (this.overlayRef && this.overlayRef.contains(event.target)) {
      return;
    }
    event.preventDefault();
    event.stopPropagation();
  };

  render() {
    return (
      <div
        ref={(node) => { this.overlayRef = node; }}
        className="hlas-maintenance-overlay"
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="hlas-maintenance-title"
        aria-describedby="hlas-maintenance-message"
      >
        <div className="hlas-maintenance-overlay__card">
          <div className="hlas-maintenance-overlay__bar" />
          <div className="hlas-maintenance-overlay__body">
            <img
              className="hlas-maintenance-overlay__logo"
              src={`${getAssetHost()}/common/hlas_logo.png`}
              alt="HL Assurance"
            />
            <h1 id="hlas-maintenance-title" className="hlas-maintenance-overlay__title">
              We’re Upgrading For You
              <br />
              We’ll Be Back Soon!
            </h1>
            <div id="hlas-maintenance-message">
              <p className="hlas-maintenance-overlay__message">
                Our systems are currently undergoing scheduled maintenance and may be temporarily unavailable.
              </p>
              <p className="hlas-maintenance-overlay__message">
                We apologise for any inconvenience caused and appreciate your patience and understanding while we work to restore full service.
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default MaintenanceOverlay;
